import React, { Component, Fragment } from 'react';
import { PageWrapper, ErrorRedirect, PageLoader } from './../components';
import ArticleHero from './blog/blog_single/article_hero';
import ArticleFlexLayout from './blog/blog_single/article_flex_layout';

export default class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wpData: {},
      loading: true,
      error: false
    };
    this.slug = `${process.env.API_URL}article/?name=`;
  }

  componentDidMount() {
    this._apiRequest(`${this.slug}${this.props.match.params.pageSlug}&type=${this.props.postType}`);
  }
  
  componentWillReceiveProps(nextProps) {
    this._apiRequest(`${this.slug}${nextProps.match.params.pageSlug}&type=${this.props.postType}`);
  }

  _apiRequest(url) {
    fetch(url).then((response) => {
      if (!response.ok) { throw Error(response.statusText); }
      return response.json();
    }).then((res) => {
      this.setState({
        wpData: res.data,
        loading: false,
        error: false
      });
    }).catch(() => {
      this.setState({
        error: true,
        loading: false,
        wpData: false
      });
    });
  }

  render() {
    return (
      <Fragment>
        {(this.state.loading) ? <PageLoader/> : (this.state.error) ? <ErrorRedirect/>
          : <ArticleContent data={this.state.wpData}/>
        }
      </Fragment>
    );
  };
};

const ArticleContent = (props) => {
  return (
    <PageWrapper pageId={'blog-article'}>
      {(!props.data.hide_hero)&& 
       <ArticleHero heroData={props.data}/>
      }
      <ArticleFlexLayout hideHero={props.data.hide_hero} flexData={props.data.flexible_layout} pageId={props.data.page_id}/>
    </PageWrapper>
  );
};




// WEBPACK FOOTER //
// ./src/pages/SingleArticle.js